import { React, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ENDPOINT, KEY } from "config/constants";
import AuthService from "services/auth.service";
import accessHeader from "services/headers/access-header";
import swal from 'sweetalert';

const AddFaqPopup = (props) => {

    const [formData, setFormData] = useState({});
    const [addAdmin, setAddAdmin] = useState(false);

    const handleChange = (event) => {

        let value = event.target.value;
        let name = event.target.name;
        setFormData((prevalue) => {
            return {
                ...prevalue,   // Spread Operator               
                [name]: value
            }
        })
    }


    const submitForm = async (event) => {
        event.preventDefault();
        try {
            // First API call
            const dataObj = {
              type: "faq",
              question: formData.question,
              description: formData.description,
            };
            const res = await AuthService.postMethod(`${ENDPOINT.admin_guidelines.add_faq}`, true, dataObj);

            if (res.status === 201) {
                toast.success('Data submitted successfully', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            }
            props.guidlinessWaiverData()
            setTimeout(() => {
                setAddAdmin(props.onHide);
            }, 1000);
            console.log("res", res.data);

        } catch (err) {
            // swal("Error", `${AuthService.errorMessageHandler(err)}`, "error");
        }
    };

    return (
        <>
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Button variant="close" onClick={props.onHide}><i className={"fal fa-times"}></i> </Button>

                <Modal.Body style={{ padding: '14px 41px', marginTop:"12px" }}>
                    <Button variant={"back"} className={"font-18 fw-bold mt-3"} onClick={props.onHide} >Add FAQ</Button>

                    <Form onSubmit={submitForm}>
                  
          
                        <Form.Group className={"mb-3"}>
                        <label htmlFor="">Title</label>
                            <Form.Control type="text"
                                required
                                name="question"
                                value={formData.question}
                                onChange={handleChange}
                                placeholder="Title here..." />
                        </Form.Group>
                        <Form.Group className={"mb-3"}>
                        <label htmlFor="">Description</label>
                            <textarea required
                                name="description"
                                value={formData.description}
                                onChange={handleChange} placeholder="Description here...">

                            </textarea>
                        </Form.Group>
                        <div className={"text-center"}>
                            <Button type="submit" variant="success" style={{width:'30%'}}>Save</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddFaqPopup;